import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertCircle, TrendingUp, XCircle } from 'lucide-react';
export function UrgencySection() {
  return <SectionWrapper bgColor="cream" data-id="element-317">
      <div className="bg-urgency/5 border border-urgency/20 rounded-3xl p-6 md:p-8" data-id="element-318">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-319">
          <AlertCircle className="w-8 h-8 text-urgency animate-pulse" data-id="element-320" />
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-urgency" data-id="element-321">
            Precio de Lanzamiento — Tiempo Limitado
          </h2>
        </div>

        <p className="text-center font-sans text-lg text-gray-800 mb-5" data-id="element-322">
          Este bundle completo está disponible por <strong data-id="element-323">$6.39 USD</strong>{' '}
          únicamente durante el período de lanzamiento.
        </p>

        <div className="bg-white rounded-2xl p-5 max-w-md mx-auto mb-5 shadow-sm" data-id="element-324">
          <p className="font-bold text-gray-500 uppercase text-sm mb-3 text-center" data-id="element-325">
            Una vez que termine esta fase:
          </p>
          <ul className="space-y-4" data-id="element-326">
            <li className="flex items-center gap-3 text-gray-700" data-id="element-327">
              <TrendingUp className="w-5 h-5 text-urgency" data-id="element-328" />
              <span data-id="element-329">El precio sube a $27 USD</span>
            </li>
            <li className="flex items-center gap-3 text-gray-700" data-id="element-330">
              <XCircle className="w-5 h-5 text-urgency" data-id="element-331" />
              <span data-id="element-332">Los bonos desaparecen</span>
            </li>
            <li className="flex items-center gap-3 text-gray-700" data-id="element-333">
              <XCircle className="w-5 h-5 text-urgency" data-id="element-334" />
              <span data-id="element-335">Esta oferta no regresa</span>
            </li>
          </ul>
        </div>

        <p className="text-center font-sans text-lg text-gray-800 font-medium" data-id="element-336">
          Si estás leyendo esto, el precio todavía está activo.
          <br data-id="element-337" />
          <span className="text-urgency" data-id="element-338">
            Pero no podemos garantizar que lo estará mañana.
          </span>
        </p>
      </div>
    </SectionWrapper>;
}